import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';
import FlashDialog from 'Components/FlashDialog';

class AddStudentToClassForm extends React.Component {
  render() {
    return (
      <Form
        type="addStudentToSchool"
        id="addStudentToSchool"
        formStyle={`add-school-user`}
        messagePosition="inline-form"
        submitArgs={{ schoolId: this.props.schoolId }}
        submitButtonType="add-user"
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    schoolId: reducers.getActiveSchoolId(state),
  };
};

export default connect(mapStateToProps, false)(AddStudentToClassForm);
